import PropTypes from 'prop-types';

export const classPropTypes = PropTypes.shape({
    id: PropTypes.number,
    level: PropTypes.number,
    name: PropTypes.string,
    active: PropTypes.bool,
    actual: PropTypes.bool,
});

export const classesPropTypes = PropTypes.arrayOf(classPropTypes);
